//settings
import React, { useState, useEffect }  from "react";
import { useNavigate, useLocation } from 'react-router-dom';

//styles
import StylesHeader from "./header.module.scss";

//assets
import logoB from "../../assets/logo_images/logoB.png";

//icons
import { FaHome, FaLaptopCode } from "react-icons/fa";
import { MdWorkHistory } from "react-icons/md";
import { GiSkills } from "react-icons/gi";
import { IoIosSchool } from "react-icons/io";


	
const HeaderComponent: React.FC = () => {

    const navigate = useNavigate();
	const location = useLocation();

    const [isScrolled, setIsScrolled] = useState(false);
    const [openNavMobile, setOpenNavMobile] = useState(false);
	const [routeActive, setRouteActive] = useState(0);

    useEffect(() => {
		const handleScroll = () => {
			if (window.scrollY >= 350) {
				setIsScrolled(true);
			} 
			if (window.scrollY < 250) {
				setIsScrolled(false);
			}
		};
  
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
    }, []);

	useEffect(() => {
		const locationActive = location.pathname.substring(1)
		switch (locationActive) {
			case "experience":
				setRouteActive(1);
				break;
			case "portfolio":
				setRouteActive(2);
				break;
			case "skills":
				setRouteActive(3);
				break;
			case "academic":
				setRouteActive(4);
				break;
			default:
				setRouteActive(0);
				break;
		}
		
    }, [location]);

    const linkTo = (redirectTo: string) => {
        setOpenNavMobile(false)
        navigate('/'+redirectTo);
    }

    return (
        <>
        	<div className={[StylesHeader.__main_header_container].join(' ')}>
				<div className={[ StylesHeader.__header].join(' ')}>
					<div className={[ StylesHeader.__header_logo].join(' ')}>
						<div className={[StylesHeader.__img].join(' ')}>
							<img src={logoB} alt="logo" />
						</div>
					</div>
					<div className={[StylesHeader.__header_nav_div].join(' ')}>
						<nav className={[StylesHeader.__nav].join(' ')}>
							<div className={[StylesHeader.__nav_list].join(' ')}>
								<div className={[StylesHeader.__link, routeActive === 0 ? StylesHeader.__link_active : ''].join(' ')} onClick={()=>linkTo("")}>
									<div className={[StylesHeader.__icon].join(' ')}><FaHome /></div>
									<div className={[StylesHeader.__text].join(' ')}>Inicio</div>
								</div>
								<div className={[StylesHeader.__link, routeActive === 1 ? StylesHeader.__link_active : ''].join(' ')} onClick={()=>linkTo("experience")}>
									<div className={[StylesHeader.__icon].join(' ')}><MdWorkHistory /></div>
									<div className={[StylesHeader.__text].join(' ')}>Experiencia</div>
								</div>
								<div className={[StylesHeader.__link, routeActive === 2 ? StylesHeader.__link_active : ''].join(' ')} onClick={()=>linkTo("portfolio")}>
									<div className={[StylesHeader.__icon].join(' ')}><FaLaptopCode /></div>
									<div className={[StylesHeader.__text].join(' ')}>Portafolio</div>
								</div>
								<div className={[StylesHeader.__link, routeActive === 3 ? StylesHeader.__link_active : ''].join(' ')} onClick={()=>linkTo("skills")}>
									<div className={[StylesHeader.__icon].join(' ')}><GiSkills /></div>
									<div className={[StylesHeader.__text].join(' ')}>Habilidades</div>
								</div>
								<div className={[StylesHeader.__link, routeActive === 4 ? StylesHeader.__link_active : ''].join(' ')} onClick={()=>linkTo("academic")}>
									<div className={[StylesHeader.__icon].join(' ')}><IoIosSchool /></div>
									<div className={[StylesHeader.__text].join(' ')}>Formación</div>
								</div>
							</div>
						</nav>
					</div>
				</div>	
			</div>  
        </>
    );
}

export default HeaderComponent;